{
  "static-content-become-partner": {
    "buttons": {
      "be-partner": "Be Partner"
    },
    "text": {
      "title": "Are you a beauty salon owner? Bring it online today!",
      "description": "Don't wait any longer, schedule a demo today to see how our App can transform your salon management. Our software is user-friendly and customizable to meet the unique needs of your salon. It's time to take your salon to the next level of efficiency and customer satisfaction. Become our partner today!"
    }
  }
}
